import { useEffect, useRef } from 'react';
import axios from 'axios';

/**
 * Hook para manter o backend "aquecido" (warm)
 * Chama o endpoint /warmup periodicamente para evitar que o backend "durma"
 */
export const useBackendWarmup = () => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const warmupBackend = async () => {
      try {
        // Warmup usando endpoint de health check
        const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';
        // Remove /api/v1 se estiver presente e adiciona /health
        const healthUrl = baseUrl.replace(/\/api\/v1$/, '') + '/health';
        await axios.get(healthUrl, {
          timeout: 3000, // 3 segundos de timeout
        });
      } catch (error) {
        // Silenciosamente ignora erros - não queremos interromper a experiência do usuário
        console.debug('Backend warmup ping failed (this is normal)');
      }
    };

    // Chama imediatamente ao montar
    warmupBackend();

    // Configura intervalo para chamar a cada 5 minutos
    intervalRef.current = setInterval(warmupBackend, 5 * 60 * 1000); // 5 minutos

    // Cleanup ao desmontar
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);
};

